<template>
  <div class="relative flex-1">
    <Search
      :size="16"
      color="#64748b"
      class="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
    />
    <input
      :value="modelValue"
      @input="handleInput"
      @keydown.enter="handleEnter"
      @blur="handleBlur"
      type="search"
      :placeholder="placeholder"
      class="w-full py-2.5 pl-10 pr-7 border border-slate-200 rounded-lg text-sm outline-none transition-all duration-200 bg-gradient-to-r from-white to-slate-50 focus:border-blue-500 focus:shadow-[0_0_0_3px_rgba(59,130,246,0.1)] focus:bg-white placeholder:text-slate-400"
    />
    <button
      v-if="modelValue && showClearButton"
      @click="handleClear"
      class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-none border-none cursor-pointer p-1 rounded transition-colors duration-200 hover:bg-blue-500/10"
    >
      <X :size="14" color="#64748b" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { Search, X } from 'lucide-vue-next'

defineProps<{
  modelValue: string
  placeholder?: string
  showClearButton?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
  clear: []
  search: []
}>()

let searchTimeout: number | null = null

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.value)

  // 防抖：停止输入300ms后自动触发搜索
  if (searchTimeout) {
    clearTimeout(searchTimeout)
  }
  searchTimeout = window.setTimeout(() => {
    emit('search')
  }, 300)
}

const handleEnter = () => {
  if (searchTimeout) {
    clearTimeout(searchTimeout)
  }
  emit('search')
}

const handleBlur = () => {
  // 失去焦点时触发搜索（移动端常用）
  if (searchTimeout) {
    clearTimeout(searchTimeout)
  }
  // 短暂延迟，避免与其他事件冲突
  setTimeout(() => {
    emit('search')
  }, 100)
}

const handleClear = () => {
  if (searchTimeout) {
    clearTimeout(searchTimeout)
  }
  emit('update:modelValue', '')
  emit('clear')
}
</script>
